import React, { Fragment, useEffect, useState } from "react";
import Loader from "react-loaders";
import {
    Button,
    Col,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
  } from "reactstrap";
  import {api} from "../../_services/api.service";
  import {PartnerAlternativeMetricRenderer} from "./Components/PartnerAlternativeMetricRenderer";

const AlternativePreviewModal = ({
    partnerAlternativeId,
    partnerScenarioId,
    showMainModal,
    toggleMainModal,
}) => {

    let defaultAlternative = {
        partnerAlternativeID: -1,
        partnerAlternativeMetrics: [],
        partnerScenarioID: partnerScenarioId,
        partnerAlternativeName: "",
        infoLink: "",
        actionLink: "",
        cost: "",
        description: "",
    };

    let [alternative, setAlternative] = useState(defaultAlternative);
    let [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (showMainModal && partnerAlternativeId > -1) {
            loadData();
        } else if (showMainModal) {
            setAlternative({
                ...defaultAlternative,
                partnerScenarioID: partnerScenarioId,
            });
        }
    }, [showMainModal, partnerAlternativeId]);

    const loadData = () => {
        loadAlternative(partnerAlternativeId);
    };

    const loadAlternative = (id) => {
        if (id > 0) {
            setIsLoading(true);
            api.getPartnerAlternativeById(id).then((data) => {
                if (data.partnerAlternativeMetrics === undefined) {
                    data.partnerAlternativeMetrics = [];
                }
                setAlternative(data);
                setIsLoading(false);
            });
        }
    };

    return (
        <Modal
            size="md"
            isOpen={showMainModal}
            toggle={toggleMainModal}
            backdrop="static"
        >
            <Fragment>
                <ModalHeader toggle={toggleMainModal}>Information</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md="12">
                            {isLoading && (
                                <Loader style={{}} type="ball-pulse" active />
                            )}
                            {!isLoading && alternative !== null && (
                                <div>
                                    <h3>{alternative.partnerAlternativeName}</h3>
                                    {alternative.partnerAlternativeMetrics !== null &&
                                        alternative.partnerAlternativeMetrics.map(
                                            (pam, idx) => {
                                                return PartnerAlternativeMetricRenderer(pam, idx);
                                            }
                                        )}
                                    <p>
                                        <span style={{ fontWeight: "bold" }}>Description:</span>{" "}
                                        {alternative.description}
                                    </p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <Button outline color="primary" onClick={toggleMainModal}>
                        Close
                    </Button>
                </ModalBody>
            </Fragment>
        </Modal>
    )
};

export default AlternativePreviewModal;